export default {"src":"/_next/static/media/precision-manufacturing.437b8d53.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};